export default __webpack_public_path__ + "static/media/slide1.ec56b1e4.svg";